// extracted by mini-css-extract-plugin
export default {"description":"_77e9d3d5"};